import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconClockSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconClockSquare"><Path d="M20.5 3.5H3.5V20.5H20.5V3.5Z" stroke="currentColor" strokeLinecap="square"/><Circle cx="12" cy="12" r="5.5" stroke="currentColor"/><Path d="M12 9.5V11.9996L14 14" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconClockSquare;
